<template>
  <main class="site-unavailable">
    <h1>赛事站点暂不可用</h1>
    <p>{{ message }}</p>
    <button @click="retry">重试</button>
  </main>
</template>

<script>
export default {
  computed: {
    message () {
      return this.$route.query.reason || '请检查赛事网址，或联系赛事主办方。'
    }
  },
  methods: {
    retry () { window.location.assign('/home') }
  }
}
</script>

<style scoped>
.site-unavailable { max-width: 640px; margin: 12vh auto; padding: 32px; text-align: center; color: #333; }
.site-unavailable h1 { font-size: 28px; }
.site-unavailable p { font-size: 16px; line-height: 1.6; }
.site-unavailable button { padding: 10px 28px; border: 0; border-radius: 4px; background: #0674dc; color: white; cursor: pointer; }
</style>
